import Button from 'src/components/button/Button';
import IconSvg from '../../../../components/common/ui/IconSvg';
import { useNavigate } from 'react-router-dom';
import {ethers} from "ethers";
import SyncLoader from "react-spinners/SyncLoader";

interface Props {
  bannerImg: string;
  btnText: string;
  slug: string;
  title: string;
  status: string;
  collectionImage: string;
  id: string | undefined;
  website: string;
  twitter: string;
  stageId: string;

  arenaTotalMintedKeys: string;
  projectType: string;
  showButtons?: boolean;
}

const HomeBanner = ({
  bannerImg,
  btnText,
  title,
  status,
  collectionImage,
  id,
  slug,
  website,
  twitter,
  projectType,
  showButtons,
  stageId,
  arenaTotalMintedKeys,
}: Props) => {
  const navigate = useNavigate();



  return (
    <div
      className="xl:h-[418px] rounded-md w-full px-10 py-[41.5px] pb-[63.5px] bg-grayscale-800 flex flex-col justify-between relative"
      style={{
        backgroundImage: `url(${bannerImg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="absolute inset-0 bg-black bg-opacity-50"></div>
      <div className="z-10 flex justify-between">
        <div>
          <div
            className={`py-2 px-[15px] rounded-md mb-3 flex gap-1.5 items-center border w-fit ${
              status === 'Live'
                ? 'bg-system-success-dark border-system-success'
                : 'bg-system-warning-dark border-system-warning'
            }`}
          >
            <IconSvg icon={status === 'Live' ? 'liveS' : 'comingSoonS'} />

            <span className="text-sm text-grayscale-100">{status}</span>
          </div>
        </div>

        <div className="flex gap-3">
          <div className="bg-black bg-opacity-70 py-3 px-[18px] rounded-md">
            <div className="mb-2 text-sm text-grayscale-200 text-end">Value of Rewards</div>

            <div className="text-[24px] font-bold text-grayscale-100">
              {slug === 'arena' ? '$20,000' : slug === 'multiversx' ? '≈ $50,000' : '≈ $150,000'}
            </div>
          </div>

          {slug === 'arena' && (
            <div className="bg-black bg-opacity-70 py-3 px-[18px] rounded-md">
              <div className="mb-2 text-sm text-grayscale-200 text-end">Minted Keys</div>

              <div className="text-[24px] font-bold text-grayscale-100">
                <div className="flex">
                  <div>
                    {arenaTotalMintedKeys !== '' ? (
                      Number(arenaTotalMintedKeys).toLocaleString()
                    ) : (
                      <SyncLoader color="#B73FFF" size={5} />
                    )}
                  </div>
                  <div>/1,629</div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="z-10 flex items-end justify-between">
        <div className="flex gap-[19px] items-center">
          <div className="w-[109px] h-[109px] rounded-md">
            <img src={collectionImage} className="object-contain w-full h-full rounded-md" />
          </div>

          <div className="space-y-[12px]">
            <div className="flex gap-[13px] items-end">
              <h3 className="uppercase text-brand-primary-light">{title}</h3>

              <div className={`text-sm text-grayscale-200 uppercase`}>{projectType}</div>
            </div>

            <div>
              <div className="flex gap-[9px] items-center">
                {slug === 'multiversx' && (
                  <div className="space-y-[5px]">
                    <button
                      onClick={() => navigate('/multiversx/leaderboard/multiversx')}
                      className="flex items-center gap-2 px-4 py-[8px] text-sm rounded-md bg-grayscale-700 w-fit text-grayscale-200"
                    >
                      <svg
                        width="12"
                        height="12"
                        viewBox="0 0 12 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M2.11111 1H1V11H2.11111H9.88889H11V1H9.88889H2.11111ZM9.88889 2.11111V9.88889H2.11111V2.11111H9.88889ZM4.33333 5.44444H3.22222V8.77778H4.33333V5.44444ZM5.44444 3.22222H6.55556V8.77778H5.44444V3.22222ZM8.77778 6.55556H7.66667V8.77778H8.77778V6.55556Z"
                          fill="#E6E6E6"
                        />
                      </svg>

                      <span>Leaderboard</span>
                    </button>
                  </div>
                )}

                {website && (
                  <a href={website} target="_blank" rel="noopener noreferrer">
                    <IconSvg icon="webM" className="text-[#E6E6E6]" />
                  </a>
                )}

                {twitter && (
                  <a href={twitter} target="_blank" rel="noopener noreferrer">
                    <IconSvg icon="twitterM" className="text-[#E6E6E6]" />
                  </a>
                )}
              </div>

              {slug === 'multiversx' && (
                <a
                  className="underline cursor-pointer text-xss text-grayscale-200"
                  onClick={() => navigate('/multiversx/leaderboard/multiversx')}
                >
                  Get more points
                </a>
              )}
            </div>
          </div>
        </div>

        {status === 'Live' && (
          <Button
            type="primary"
            size="m"
            onClick={() => {
              if (slug === 'arena' && stageId) {
                navigate(`/arena/${id}/${stageId}`);
              } else if (slug === 'multiversx') {
                navigate('/multiversx/leaderboard/multiversx');
              }
            }}
          >
            {btnText}
          </Button>
        )}
      </div>
    </div>
  );
};

export default HomeBanner;
